export const USERNAME_HELPER_TEXT = 'Use lowercase letters, numbers, and hyphens only.';
export const USERNAME_ERROR_TEXT = 'Your storefront URL can only include lowercase letters, numbers, and hyphens.';

const USERNAME_PATTERN = /^[a-z0-9-]+$/;
const RESERVED_STORE_PATHS = new Set(['discover']);

export function normalizeUsernameInput(input: string): string {
  return input.trim().toLowerCase();
}

export function validateNormalizedUsername(username: string): string | null {
  if (!username) return 'Username is required.';
  if (!USERNAME_PATTERN.test(username)) return USERNAME_ERROR_TEXT;
  if (RESERVED_STORE_PATHS.has(username)) return 'This storefront URL is reserved.';
  return null;
}
